<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <!-- Block 1: Thông tin xuất kho -->
        <v-flex lg12 md12 sm12>
          <v-card>
            <v-card-title class="subtitle-1 font-weight-bold">
              Thông tin xuất kho
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg3 md3 sm12>
                  <v-text-field
                    label="Mã bill"
                    readonly
                    v-model="currentItem.BillCode"
                    class="input-group--focused"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md3 sm12>
                  <v-autocomplete
                    label="Khách hàng"
                    :items="customers"
                    :item-text="(p) => { return p.Username + ' - ' + p.FullName }"
                    item-value="ID"
                    v-model="currentItem.UID"
                    :disabled="storeRole || currentItem.ID > 0 || currentItem.Status == 2"
                    outlined
                    dense
                    @change="onCustomerChange"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg3 md3 sm12>
                  <v-select
                    label="Trạng thái"
                    v-model="currentItem.Status"
                    :items="bill_status_list"
                    item-text="name"
                    item-value="value"
                    :disabled="storeRole || !hasEditPermission || currentItem.Status == 2"
                    outlined
                    dense
                  ></v-select>
                </v-flex>
                <v-flex lg3 md3 sm12>
                  <v-text-field
                    label="Số kiện"
                    readonly
                    :value="currentItem.TotalPackageCount || 0"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                
                <v-flex lg3 md3 sm12>
                  <h-currency-input
                    label="Tổng cước (Biên giới + Nội địa)"
                    :value="totalCrossBorderAndDomestic"
                    :decimal="0"
                    readonly
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                  <h-currency-input
                    label="Tổng phí giao hàng & khác"
                    :value="totalDoorAndOther"
                    :decimal="0"
                    readonly
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                  <h-currency-input
                    label="Tổng thanh toán (Final)"
                    v-model="finalAmount"
                    :decimal="0"
                    readonly
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                  <v-text-field
                    label="Ngày tạo"
                    readonly
                    :value="currentItem.CreatedDate | display_date"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                
                <v-flex lg3 md3 sm12 v-if="currentItem.ExportDate">
                  <v-text-field
                    label="Ngày xuất kho"
                    readonly
                    :value="currentItem.ExportDate | display_date"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md3 sm12 v-if="currentItem.PaymentDate">
                  <v-text-field
                    label="Ngày thanh toán"
                    readonly
                    :value="currentItem.PaymentDate | display_date"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                  <v-text-field
                    label="Địa chỉ giao hàng"
                    v-model="currentItem.DeliveryAddress"
                    :disabled="storeRole || !hasEditPermission || currentItem.Status == 2"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- Block 2: Danh sách hàng hóa -->
        <v-flex lg12 md12 sm12>
          <v-card>
            <v-card-title class="subtitle-1 font-weight-bold d-flex justify-space-between align-center">
              <span>Danh sách hàng hóa</span>
              <v-btn
                small
                color="red"
                @click="addDetail"
                :disabled="storeRole || !hasEditPermission || currentItem.ID > 0 || !currentItem.UID || currentItem.Status == 2"
              >
                <v-icon dark>add</v-icon> Chọn hàng
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="detail_header"
                :items="selectedProducts"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.Code }}</td>
                    <td>{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</td>
                    <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                    <td class="text-right">{{ item.Volume | currency('', 3) }}</td>
                    <td class="text-right">{{ item.NumberOfPackImport | currency }}</td>
                    <td class="text-right">
                      <v-edit-dialog 
                        v-if="!storeRole && hasEditPermission && currentItem.Status != 2"
                        :return-value.sync="item.ExportPack" 
                        lazy 
                        @save="calculateFee(item)"
                      >
                        <div>{{ item.ExportPack | currency }}</div>
                        <template v-slot:input>
                          <v-text-field v-model.number="item.ExportPack" type="number" label="Số kiện xuất" single-line autofocus></v-text-field>
                        </template>
                      </v-edit-dialog>
                      <div v-else>{{ item.ExportPack | currency }}</div>
                    </td>
                    <td class="text-right">{{ item.TotalFeeWeight | currency }}</td>
                    <td class="text-right">
                      <div>{{ getItemCnyVnd(item) | currency }}</div>
                      <div class="cny-subtext" v-if="item.Deposit">
                        {{ item.Deposit | currency('¥', 2) }}
                      </div>
                    </td>
                    <td class="text-right font-weight-medium">
                      {{ getItemTotalAmount(item) | currency }}
                    </td>
                    <td class="text-center">
                      <v-icon 
                        medium 
                        @click="deleteDetail(item.ID)"
                        :disabled="storeRole || !hasEditPermission || currentItem.Status == 2"
                      >delete</v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- Block 3: Giao hàng -->
        <v-flex lg12 md12 sm12>
          <v-card>
            <v-card-title class="subtitle-1 font-weight-bold">
              Giao hàng
            </v-card-title>
            <v-card-text>
              <v-simple-table dense class="delivery-table elevation-1">
                <thead>
                  <tr>
                    <th>Hình thức</th>
                    <th class="text-right">Tổng kiện</th>
                    <th class="text-right">Tổng cân</th>
                    <th class="text-right">Tổng khối</th>
                    <th class="text-right">Giá cân</th>
                    <th class="text-right">Giá khối</th>
                    <th class="text-right">Cước giao</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="font-weight-medium">
                      <v-checkbox
                        v-model="isDomesticTransport"
                        :disabled="saleRole || !hasEditPermission || currentItem.Status == 2"
                        hide-details
                        class="mt-0 pt-0"
                      >
                        <template v-slot:label>
                          <span class="font-weight-medium">Cước vận chuyển nội địa</span>
                        </template>
                      </v-checkbox>
                    </td>
                    <td class="text-right">{{ deliveryTotalPackages | currency('', 0) }}</td>
                    <td class="text-right">{{ deliveryTotalWeight | currency('', 1) }}</td>
                    <td class="text-right">{{ deliveryTotalVolume | currency('', 3) }}</td>
                    <td class="text-right delivery-cell-input">
                      <h-currency-input
                        v-model.number="currentItem.DomesticWeightUnitPrice"
                        :disabled="saleRole || !hasEditPermission || currentItem.Status == 2 || !isDomesticTransport"
                        decimal="0"
                        class="table-input table-input-right"
                      ></h-currency-input>
                    </td>
                    <td class="text-right delivery-cell-input">
                      <h-currency-input
                        v-model.number="currentItem.DomesticVolumeUnitPrice"
                        :disabled="saleRole || !hasEditPermission || currentItem.Status == 2 || !isDomesticTransport"
                        decimal="0"
                        class="table-input table-input-right"
                      ></h-currency-input>
                    </td>
                    <td class="text-right font-weight-medium">
                      {{ currentItem.DomesticTransportFee | currency('', 0) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">
                      <v-checkbox
                        v-model="isDoorDelivery"
                        :disabled="saleRole || !hasEditPermission || currentItem.Status == 2"
                        hide-details
                        class="mt-0 pt-0"
                      >
                        <template v-slot:label>
                          <span class="font-weight-medium">Phí giao hàng</span>
                        </template>
                      </v-checkbox>
                    </td>
                    <td colspan="5" class="delivery-note-cell">
                      (Tính tự động theo tổng khối giao)
                    </td>
                    <td class="text-right font-weight-medium">
                      {{ currentItem.DoorDeliveryFee | currency('', 0) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">
                      <v-checkbox
                        v-model="isOtherDelivery"
                        :disabled="saleRole || !hasEditPermission || currentItem.Status == 2"
                        hide-details
                        class="mt-0 pt-0"
                      >
                        <template v-slot:label>
                          <span class="font-weight-medium">Khác</span>
                        </template>
                      </v-checkbox>
                    </td>
                    <td colspan="5" class="delivery-cell-input">
                      <v-text-field
                        v-model="currentItem.OtherDeliveryNote"
                        hide-details
                        single-line
                        class="table-input"
                        :disabled="saleRole || !hasEditPermission || currentItem.Status == 2 || !isOtherDelivery"
                      ></v-text-field>
                    </td>
                    <td class="text-right delivery-cell-input">
                      <h-currency-input
                        v-model.number="currentItem.OtherDeliveryFee"
                        :disabled="saleRole || !hasEditPermission || currentItem.Status == 2 || !isOtherDelivery"
                        decimal="0"
                        class="table-input table-input-right"
                      ></h-currency-input>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="6" class="font-weight-bold">Thành tiền</td>
                    <td class="text-right font-weight-bold">
                      {{ deliveryGrandTotal | currency('', 0) }}
                    </td>
                  </tr>
                </tfoot>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Dialog chọn sản phẩm -->
    <v-dialog v-model="dialogItem" max-width="1300px">
      <v-card>
        <v-card-title>
          <span class="title">Chọn hàng hóa xuất kho</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
          <v-btn @click="onSelectDetail">Lưu lại</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <hpo-filter
                  :headers="popup_header"
                  :viewName="popupViewName"
                  v-on:applyFilter="applyFilterDetail"
                  v-on:quickFilter="quickFilterDetail"
                ></hpo-filter>
                <v-data-table
                  fixed-header
                  height="450px"
                  :headers="popup_header"
                  :items="popup_items"
                  item-key="ID"
                  disable-pagination
                  hide-default-footer
                  show-select
                  v-model="selectedDetail"
                >
                  <template v-slot:item="{ item, isSelected, select }">
                    <tr :active="isSelected" @click="select(!isSelected)">
                      <td>
                        <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                      </td>
                      <td>{{ item.Code }}</td>
                      <td>{{ item.UserName }}</td>
                      <td>{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</td>
                      <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                      <td class="text-right">{{ item.Volume | currency('', 2) }}</td>
                      <td class="text-right">{{ ((item.NumberOfPackImport || 0) - (item.NumberOfPackExport || 0)) | currency }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Filtering from "@/components/Filtering";
import { mapState } from "vuex";
import configs from "@/configs";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";
import fileUploadService from "@/services/fileUploadService";
import createPermissionMixin from "@/mixins/permissionMixin";
import _ from "lodash";

export default {
  mixins: [createPermissionMixin('bill_list')],
  components: {
    "hpo-filter": Filtering,
  },
  data() {
    return {
      bill_status_enum: configs.BILL_STATUS,
      bill_status_list: configs.BILL_STATUS_LIST,
      product_status: configs.PRODUCT_STATUS,
      selectedProducts: [],
      dialogItem: false,
      popupViewName: "popup_bill_detail",
      selectedDetail: [],
      filterConditions: [],
      quickFilterConditions: [],
      paymentFile: null,
      paymentFileUrl: null,
      uploadingFile: false,
      detail_header: [
        { text: 'Mã HN', value: 'Code', sortable: false },
        { text: 'Loại hàng', value: 'ProductTypeName', sortable: false },
        { text: 'Cân nặng', value: 'Weight', align: 'end', sortable: false },
        { text: 'Thể tích', value: 'Volume', align: 'end', sortable: false },
        { text: 'Tồn kho VN', value: 'NumberOfPackImport', align: 'end', sortable: false },
        { text: 'Kiện xuất', value: 'ExportPack', align: 'end', sortable: false },
        { text: 'Phí vận chuyển', value: 'TotalFeeWeight', align: 'end', sortable: false },
        { text: 'Chi tệ', value: 'TotalDepositAmount', align: 'end', sortable: false },
        { text: 'Thành tiền', value: 'LineAmount', align: 'end', sortable: false },
        { text: 'Thao tác', value: '', width: '80px', sortable: false },
      ],
      popup_header: [
        { text: 'Mã HN', value: 'Code', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE["String"] },
        { text: 'Mã KH', value: 'UserName', filterable: true, dataType: configs.DATA_TYPE["String"] },
        { text: 'Loại hàng', value: 'ProductTypeName', filterable: true, dataType: configs.DATA_TYPE["String"] },
        { text: 'Cân', value: 'Weight', align: 'end', filterable: true, dataType: configs.DATA_TYPE["Number"] },
        { text: 'Khối', value: 'Volume', align: 'end', filterable: true, dataType: configs.DATA_TYPE["Number"] },
        { text: 'Tồn VN', value: 'AvailablePack', align: 'end', filterable: true, dataType: configs.DATA_TYPE["Number"] },
      ],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.bill.loading,
      currentItem: state => state.bill.selected,
      customers: state => state.customer.master.data,
      popup_items: state => state.product.all.data,
      product_types: state => state.productType.all.data,
      fee_weights: state => state.feeWeight.all.data,
      fee_volumes: state => state.feeVolume.all.data,
    }),
    currentId() {
      return this.$route.params.Pid == 'new' ? 0 : Number(this.$route.params.Pid);
    },
    saleRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Sale;
    },
    accountantRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant;
    },
    storeRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.StoreBatch || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.StoreEcomerce;
    },
    finalAmount() {
      return (this.currentItem.AmountVND || 0) + 
             (this.currentItem.DomesticTransportFee || 0) + 
             (this.currentItem.DoorDeliveryFee || 0) + 
             (this.currentItem.OtherDeliveryFee || 0);
    },
    totalCrossBorderAndDomestic() {
      return (this.currentItem.AmountVND || 0) + (this.currentItem.DomesticTransportFee || 0);
    },
    totalDoorAndOther() {
      return (this.currentItem.DoorDeliveryFee || 0) + (this.currentItem.OtherDeliveryFee || 0);
    },
    deliveryTotalPackages() {
      return this.selectedProducts.reduce((sum, p) => sum + (Number(p.ExportPack || 0)), 0) || (this.currentItem.TotalPackageCount || 0);
    },
    deliveryTotalWeight() {
      const total = this.selectedProducts.reduce((sum, p) => sum + (Number(p.Weight || 0)), 0);
      return total || Number(this.currentItem.TotalDomesticWeight || 0);
    },
    deliveryTotalVolume() {
      const total = this.selectedProducts.reduce((sum, p) => sum + (Number(p.Volume || 0)), 0);
      return total || Number(this.currentItem.TotalDomesticVolume || 0);
    },
    deliveryGrandTotal() {
      return (this.currentItem.DomesticTransportFee || 0) +
             (this.currentItem.DoorDeliveryFee || 0) +
             (this.currentItem.OtherDeliveryFee || 0);
    },
    isDomesticTransport: {
      get() {
        return ((this.currentItem.DeliveryMethodFlags || 0) & 1) !== 0;
      },
      set(val) {
        let flags = this.currentItem.DeliveryMethodFlags || 0;
        if (val) {
          flags |= 1;
        } else {
          flags &= ~1;
          this.currentItem.DomesticWeightUnitPrice = 0;
          this.currentItem.DomesticVolumeUnitPrice = 0;
        }
        this.$set(this.currentItem, 'DeliveryMethodFlags', flags);
      }
    },
    isDoorDelivery: {
      get() {
        return ((this.currentItem.DeliveryMethodFlags || 0) & 2) !== 0;
      },
      set(val) {
        let flags = this.currentItem.DeliveryMethodFlags || 0;
        if (val) {
          flags |= 2;
        } else {
          flags &= ~2;
        }
        this.$set(this.currentItem, 'DeliveryMethodFlags', flags);
      }
    },
    isOtherDelivery: {
      get() {
        return ((this.currentItem.DeliveryMethodFlags || 0) & 4) !== 0;
      },
      set(val) {
        let flags = this.currentItem.DeliveryMethodFlags || 0;
        if (val) {
          flags |= 4;
        } else {
          flags &= ~4;
          this.currentItem.OtherDeliveryFee = 0;
          this.currentItem.OtherDeliveryNote = '';
        }
        this.$set(this.currentItem, 'DeliveryMethodFlags', flags);
      }
    }
  },
  watch: {
    currentItem() {
      if (this.currentItem.Products && this.currentItem.Products.length > 0) {
        this.selectedProducts = [...this.currentItem.Products];
        this.selectedProducts.forEach(p => {
          p.ExportPack = p.BillNumberOfPack || p.NumberOfPackImport || 0;
        });
      }
      // Load payment file URL if exists
      if (this.currentItem.PaymentFile) {
        this.paymentFileUrl = this.currentItem.PaymentFile;
      }
    },
    hasEditPermission: {
      immediate: true,
      handler(val) {
        this.$root.$emit('REQUEST_ROOT_OPTION', {
          invisibleSaveButton: !val,
          invisibleCreateButton: !val
        });
      }
    }
  },
  methods: {
    getDetail() {
      if (!this.currentId) {
        this.$store.commit("bill/setDetail", { 
          ID: 0, 
          Status: this.bill_status_enum.chua_xuat, 
          Products: [],
          DeliveryMethodFlags: 0,
          DomesticWeightUnitPrice: 0,
          DomesticVolumeUnitPrice: 0,
          OtherDeliveryFee: 0,
          OtherDeliveryNote: '',
          DeliveryAddress: '',
          DomesticTransportFee: 0,
          DoorDeliveryFee: 0,
          TotalDomesticWeight: 0,
          TotalDomesticVolume: 0,
          TotalPackageCount: 0
        });
        this.selectedProducts = [];
      } else {
        this.$store.dispatch("bill/getDetail", this.currentId).then(() => {
          if (this.currentItem.Products) {
            this.selectedProducts = [...this.currentItem.Products];
          }
        });
      }
    },
    onCustomerChange() {
      if (this.currentItem.UID) {
        this.getAvailableProduct();
      }
    },
    getAvailableProduct() {
      this.selectedDetail = [];
      this.selectedProducts = [];
      var param = {
        pagination: { page: 1, itemsPerPage: 1000, sortBy: ['ID'], sortDesc: [true] },
        filter: [...this.filterConditions],
        quickFilter: this.quickFilterConditions
      };
      param.filter.push({
        column: 'UID',
        value: this.currentItem.UID,
        condition: 'equal',
      });
      param.filter.push({
        column: 'Status',
        value: [this.product_status.nhap_kho_vn],
        condition: 'in',
      });
      param.action = "ton-kho-vn";
      this.$store.dispatch("product/getList", param);
    },
    addDetail() {
      if (!this.hasEditPermission) {
        return;
      }
      this.dialogItem = true;
      this.getAvailableProduct();
    },
    deleteDetail(id) {
      if (!this.hasEditPermission) {
        return;
      }
      this.selectedProducts = this.selectedProducts.filter(p => p.ID !== id);
      this.recalculateTotal();
    },
    onSelectDetail() {
      if (this.selectedDetail.length > 0) {
        for (const item of this.selectedDetail) {
          const exists = this.selectedProducts.find(p => p.ID === item.ID);
          if (!exists) {
            const availablePack = (item.NumberOfPackImport || 0) - (item.NumberOfPackExport || 0);
            this.selectedProducts.push({
              ...item,
              ExportPack: availablePack,
              TotalFee: 0,
              TotalFeeWeight: 0,
              TotalDepositAmount: Math.round(Number(item.Deposit || 0) * Number(item.ExchangeRate || 0))
            });
            this.calculateFee(this.selectedProducts[this.selectedProducts.length - 1]);
          }
        }
        this.selectedDetail = [];
        this.dialogItem = false;
        this.recalculateTotal();
      }
    },
    calculateFee(item) {
      const availablePack = (item.NumberOfPackImport || 0) - (item.NumberOfPackExport || 0);
      if (item.ExportPack > availablePack) {
        item.ExportPack = availablePack;
      }
      if (item.ExportPack < 0) {
        item.ExportPack = 0;
      }

      const productType = this.product_types.find(pt => pt.ID == item.ProductType);
      if (!productType) {
        item.TotalFee = 0;
        item.TotalFeeWeight = 0;
        return;
      }

      let fee = 0;
      const weight = item.Weight || 0;
      const volume = item.Volume || 0;

      const feeWeight = this.fee_weights.find(fw => 
        fw.ProductTypeID == item.ProductType && 
        weight >= (fw.FromWeight || 0) && 
        weight <= (fw.ToWeight || 999999)
      );
      
      const feeVolume = this.fee_volumes.find(fv => 
        fv.ProductTypeID == item.ProductType && 
        volume >= (fv.FromVolume || 0) && 
        volume <= (fv.ToVolume || 999999)
      );

      const weightFee = feeWeight ? weight * (feeWeight.Price || 0) : 0;
      const volumeFee = feeVolume ? volume * (feeVolume.Price || 0) : 0;

      fee = Math.max(weightFee, volumeFee);
      item.TotalFee = Math.round(fee);
      item.TotalFeeWeight = item.TotalFee;
      this.recalculateTotal();
    },
    getItemCnyVnd(item) {
      if (item.TotalDepositAmount != null && item.TotalDepositAmount !== '') {
        return Number(item.TotalDepositAmount);
      }
      return Math.round(Number(item.Deposit || 0) * Number(item.ExchangeRate || 0));
    },
    getItemTotalAmount(item) {
      const fee = Number(item.TotalFeeWeight != null ? item.TotalFeeWeight : (item.TotalFee || 0));
      return fee + this.getItemCnyVnd(item);
    },
    recalculateTotal() {
      // this.currentItem.TotalAmount = this.selectedProducts.reduce((sum, p) => sum + (p.TotalFee || 0), 0);
    },
    applyFilterDetail(filterConditions) {
      this.filterConditions = filterConditions;
      this.getAvailableProduct();
    },
    quickFilterDetail(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.getAvailableProduct();
    },
    async onPaymentFileChange(file) {
      if (!this.hasEditPermission) {
        return;
      }
      if (!file) {
        this.paymentFile = null;
        this.paymentFileUrl = null;
        return;
      }
      
      // Validate file
      const validation = fileUploadService.validateFile(file, ['jpg', 'jpeg', 'png', 'pdf'], 10);
      if (!validation.valid) {
        sendErrorNotice(validation.message);
        this.paymentFile = null;
        return;
      }
      
      // Generate preview for images
      const previewUrl = fileUploadService.generatePreviewUrl(file);
      if (previewUrl) {
        this.paymentFileUrl = previewUrl;
      }
    },
    async uploadPaymentFile() {
      if (!this.paymentFile) {
        return null;
      }
      
      this.uploadingFile = true;
      try {
        const result = await fileUploadService.uploadSingleFile(this.paymentFile, 'bill');
        if (result.success) {
          // Prepend API base URL to relative path
          const fullUrl = `${result.data.url}`;
          this.paymentFileUrl = fullUrl;
          return fullUrl;
        } else {
          sendErrorNotice(result.message);
          return null;
        }
      } catch (error) {
        sendErrorNotice('Lỗi upload file: ' + error.message);
        return null;
      } finally {
        this.uploadingFile = false;
      }
    },
    async deletePaymentFile() {
      if (!this.hasEditPermission) {
        return;
      }
      if (!confirm('Bạn có chắc muốn xóa file thanh toán?')) {
        return;
      }
      
      this.paymentFile = null;
      this.paymentFileUrl = null;
      this.currentItem.PaymentFile = null;
      sendSuccessNotice('Đã xóa file thanh toán');
    },
    isImageFile(url) {
      if (!url) return false;
      const ext = url.split('.').pop().toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif'].includes(ext);
    },
    async saveData() {
      if (!this.hasEditPermission) {
        sendErrorNotice('Bạn không có quyền chỉnh sửa phiếu xuất kho');
        return;
      }
      if (!this.currentItem.UID) {
        sendErrorNotice('Vui lòng chọn khách hàng');
        return;
      }
      if (this.selectedProducts.length === 0) {
        sendErrorNotice('Vui lòng chọn ít nhất một mã hàng');
        return;
      }

      // Upload payment file if new file selected
      if (this.paymentFile) {
        const uploadedUrl = await this.uploadPaymentFile();
        if (uploadedUrl) {
          this.currentItem.PaymentFile = uploadedUrl;
        } else {
          sendErrorNotice('Lỗi upload file thanh toán');
          return;
        }
      }

      const payload = {
        ...this.currentItem,
        Products: this.selectedProducts.map(p => ({
          ID: p.ID,
          NumberOfPack: p.ExportPack,
          TotalFee: p.TotalFee
        }))
      };

      this.$store.dispatch("bill/setDetail", {
        data: payload,
        id: this.currentItem.ID
      }).then((ret) => {
        if (!this.currentItem.ID && ret.data) {
          this.$router.push({
            name: "BillDetail",
            params: { Pid: ret.data.ID, title: `Chi tiết xuất hàng` },
          });
        }
        sendSuccessNotice('Lưu thành công');
        this.paymentFile = null; // Reset file input after save
        this.selectedProducts = [];
        this.selectedDetail = [];
        this.getDetail();
      }).catch(err => {
        sendErrorNotice('Lỗi: ' + err.message);
      });
    },
    exportData() {
      this.$store.dispatch("bill/exportDetail", this.currentItem.ID);
    },
    exportBill() {
      if (!this.hasEditPermission || this.saleRole || this.accountantRole) {
        sendErrorNotice('Bạn không có quyền thực hiện hành động này');
        return;
      }
      if (!this.currentItem.UID) {
        sendErrorNotice('Vui lòng chọn khách hàng');
        return;
      }
      const payload = {
        ...this.currentItem,
        Status: this.bill_status_enum.da_xuat,
      };
      this.$store.dispatch("bill/setDetail", {
        data: payload,
        id: this.currentItem.ID
      });
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username", "FullName", "PhoneNumber", "Address"]
      });
    },
  },
  mounted() {
    this.$store.dispatch("productType/getList");
    this.$store.dispatch("feeWeight/getList");
    this.$store.dispatch("feeVolume/getList");
    this.getCustomerList();
    this.getDetail();
    this.$root.$on("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$on("REQUEST_CREATE_DATA", this.exportBill);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$off("REQUEST_CREATE_DATA", this.exportBill);
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
  },
};
</script>

<style>
.delivery-table td,
.delivery-table th {
  border: 1px solid #d0d0d0;
  padding: 10px 12px !important;
  vertical-align: middle;
}

.delivery-table .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.delivery-cell-input .v-input {
  margin-top: 0;
  padding-top: 0;
}

.table-input {
  padding-top: 0;
  margin-top: 0;
}

.table-input-right input {
  text-align: right !important;
}

.delivery-note-cell {
  color: #444;
}
.cny-subtext {
  font-size: 11px;
  color: #888;
  line-height: 1.2;
}
</style>
